import isBlank from "@sedan-utils/is-blank";
String.prototype.defaultAsNull = function () {
    if (isBlank(this)) {
        return undefined;
    }
    return this;
};
Array.prototype.first = function () {
    if (this.length === 0) {
        return undefined;
    }
    return this[0];
};
Array.prototype.last = function () {
    if (this.length === 0) {
        return undefined;
    }
    return this[this.length - 1];
};
Array.prototype.get = function (index) {
    if (this.length <= index) {
        return undefined;
    }
    return this[index];
};
